/**
 * Transport Metrics Context
 *
 * Shares transport selection metrics (weight, width, length)
 * between TransportDetail page and the Header component.
 */

import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface TransportMetrics {
  totalWeight: number;
  maxWidth: number;   // in inches
  maxLength: number;  // in inches
  count: number;
}

interface TransportMetricsContextValue {
  metrics: TransportMetrics | null;
  setMetrics: (metrics: TransportMetrics | null) => void;
}

const TransportMetricsContext = createContext<TransportMetricsContextValue>({
  metrics: null,
  setMetrics: () => {},
});

export function TransportMetricsProvider({ children }: { children: ReactNode }): JSX.Element {
  const [metrics, setMetricsState] = useState<TransportMetrics | null>(null);

  const setMetrics = useCallback((m: TransportMetrics | null) => {
    setMetricsState(m);
  }, []);

  return (
    <TransportMetricsContext.Provider value={{ metrics, setMetrics }}>
      {children}
    </TransportMetricsContext.Provider>
  );
}

export function useTransportMetrics(): TransportMetricsContextValue {
  return useContext(TransportMetricsContext);
}
